import type {
  Auth0ChangePasswordErrorName,
  FriendlyChangePasswordError,
} from '../../../modules/Auth0/types';
import { invalidPasswordErrors } from '../../../modules/Auth0/utils/mapError';

export const isErrorPasswordRelated = (formState: any): boolean => {
  let errorPasswordRelated = false;
  Object.keys(invalidPasswordErrors).forEach((pwdkey) => {
    const mappedValue =
      invalidPasswordErrors[
        pwdkey as keyof Record<
          Auth0ChangePasswordErrorName,
          FriendlyChangePasswordError
        >
      ];
    if (formState?.error === String(mappedValue)) {
      errorPasswordRelated = true;
    }
  });
  return errorPasswordRelated;
};
